import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge/watermark
const removeEmergentBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.remove();
  }
  // Also check for any dynamically injected badges
  const badges = document.querySelectorAll('[id*="emergent"], [class*="emergent"], a[href*="emergent"]:not([data-keep])');
  badges.forEach(el => {
    if (el.closest('nav') || el.closest('header') || el.closest('footer')) return;
    el.remove();
  });
};

// Run immediately and after DOM updates
removeEmergentBadge();
setTimeout(removeEmergentBadge, 100);
setTimeout(removeEmergentBadge, 500);
setTimeout(removeEmergentBadge, 1000);
setTimeout(removeEmergentBadge, 2000);

// Also observe for any dynamically added badges
const observer = new MutationObserver(removeEmergentBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
